import connectionTypes from '../../consts/connectionTypes';

const isCellular = (type) => type === connectionTypes.CELLULAR;
const isWiFi = (type) => type === connectionTypes.WIFI;
const isBle = (type) => type === connectionTypes.BLE;
const isSidewalk = (type) => type === connectionTypes.SIDEWALK;

export default {
    isCellular,
    isWiFi,
    isBle,
    isSidewalk,
};
